import { render, staticRenderFns } from "./CustomFieldValue.vue?vue&type=template&id=9edaf47a&"
import script from "./CustomFieldValue.vue?vue&type=script&lang=js&"
export * from "./CustomFieldValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports